import {LI_AUTH_TOKEN} from "./config";

export default class ApiConfig {
    static generateHeaders() {
        return { headers: { "x-auth-token": localStorage.getItem(LI_AUTH_TOKEN)  } }
    }
}
